/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import { Routes, Route } from 'react-router-dom'
import UserRoutes from '@/pages/User'
import {
  assetsBatchesUrls,
  listMultipleAssetsUrls,
  assetUrls,
  organizationUrls,
  userUrls,
  samsUrls,
  manageSamListingsUrls,
  pendingSamsUrls,
  samsBuildBatchesUrls
} from '@/configs/urls'
import AssetsRoutes from '@/pages/Assets'
import ListMultipleAssets from '@/pages/ListMultipleAssets'
import { ErrorProvider } from '@/components/providers/ErrorProvider'
import AssetsBatches from '@/pages/AssetsBatches'
import OrganizationRoutes from '@/pages/Organization'
import SamsRoutes from '@/pages/Sams'
import BuildSamsBatchesRoutes from '@/pages/BuildSamsBatches'
import ManageSamListingsRoutes from '@/pages/ManageSamListings'
import PendingSams from '@/pages/PendingSams'

const AuthenticatedRoutes = () => {
  return (
    <ErrorProvider>
      <Routes>
        <Route path={`/${userUrls.account}/*`} element={ <UserRoutes />} />
        <Route path={`/${assetsBatchesUrls.base}/*`} element={ <AssetsBatches />} />
        <Route path={`/${listMultipleAssetsUrls.base}/*`} element={ <ListMultipleAssets />} />
        <Route path={`/${assetUrls.base}/*`} element={ <AssetsRoutes />} />
        <Route path={`/${organizationUrls.base}/*`} element={ <OrganizationRoutes />} />
        <Route path={`/${samsUrls.base}/*`} element={ <SamsRoutes />} />
        <Route path={`/${samsBuildBatchesUrls.base}/*`} element={ <BuildSamsBatchesRoutes />} />
        <Route path={`/${manageSamListingsUrls.base}/*`} element={ <ManageSamListingsRoutes />} />
        <Route path={`/${pendingSamsUrls.base}/*`} element={ <PendingSams />} />
      </Routes>
    </ErrorProvider>
  )
}

export default AuthenticatedRoutes
